module.exports = __webpack_public_path__ + "img/bg-reservado.c3942e0f.png";